import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import getSetCookie from '../../../cookie';
import { debounce, setDataAttr } from '../../../utils/helper';
import './TopNavBar.scss';
import { NavStrip } from './NavStrip';

class TopNavBar extends PureComponent {
  static propTypes = {
    topNavData: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.isScrolled = false;
    this.state = {
      headerScroll: false,
      showChatIcon: true,
    };
    this.handleScroll = debounce(this.handleScroll.bind(this), 100);
    this.handleWidget = this.handleWidget.bind(this);
    this.countryCode = this.props.localeInfo.countryCode;
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 35) {
      this.setState({ headerScroll: true });
    } else {
      this.setState({ headerScroll: false });
    }
  }
  handleWidget(sprinklrBotEnabled) {
    // const { redisCommonData, userInfo } = this.props;
    // if (redisCommonData?.ENABLE_FRESHWORKS_DESKTOP === 'ON') {
    //     const iframe = document.getElementById('launcher-frame');
    //     let iframeDocument;
    //     if (iframe) {
    //         iframeDocument = iframe.contentWindow.document;
    //         const launcher = iframeDocument.querySelector('.launcher-button');
    //         if (launcher) {
    //             launcher.click();
    //         }
    //     }
    // } else {
    const { userInfo } = this.props;
    const { chatBotParams } = window;
    const countryCodeCookie = getSetCookie.getCookie('countryCode');
    const countryCode =
      userInfo?.countryCode ||
      (countryCodeCookie
        ? countryCodeCookie.toLowerCase()
        : process.env.COUNTRY?.toLowerCase() || global.__COUNTRY_CODE__ || 'in');
    chatBotParams.emailId = userInfo?.result?.email || '';
    chatBotParams.phoneNumber = userInfo?.result?.telephone || '';
    chatBotParams.sessionID = getSetCookie.getCookie(`clientV1_${countryCode}`) || '';
    chatBotParams.env = process.env.BUILD_ENV === 'development' ? 'preprod' : 'prod';
    chatBotParams.apiClient = process.env.CLIENT_TYPE;
    window.Freshbots?.reloadContext();
    this.setState({ showChatIcon: false });
    window.setTimeout(() => {
      if (sprinklrBotEnabled) {
        if (chatBotParams.emailId && window && window.sprChat) {
          window.sprChat('openNewConversation', {
            conversationContext: {
              '_c_62a329b623cadb2fbf33b21f ': [chatBotParams.phoneNumber], // unique ID from contact us/chat with us, maybe phone number
              _c_62a32a2c23cadb2fbf33f020: ['TRUE'], // triggeredByChatwithUs
            },
            id: chatBotParams.phoneNumber, // MANDATORY, maybe phone number
          });
        } else if (window && window.sprChat) window.sprChat('open');
      } else {
        window.Freshbots?.initiateChat();
        window.Freshbots?.showWidget(true);
      }
    }, 1000);
  }
  // }
  render() {
    const {
      topNavData,
      isSupported,
      dataLocale: { CONTACT_US },
      redisCommonData,
      // localeInfo,
    } = this.props;
    const showStrip =
      redisCommonData.SHOW_NEW_STRIP !== undefined
        ? JSON.parse(redisCommonData.SHOW_NEW_STRIP)
        : false;

    const showChatBot =
      redisCommonData && redisCommonData.SHOW_CHAT_BOT && JSON.parse(redisCommonData.SHOW_CHAT_BOT);
    // const hostCountry = redisCommonData.HOST_COUNTRY;
    const sprinklrBotEnabled = redisCommonData && redisCommonData.SPRINKLR_BOT_CONFIG;
    const newBot = sprinklrBotEnabled && JSON.parse(sprinklrBotEnabled).desktop_enabled === 'ON';
    return (
      <div className="container-fluid">
        <div
          className={`headeTopWrapper big-screen-wrapper display-flex ${
            showStrip ? 'nav-strip' : ''
          } ${showStrip && showStrip.enable ? '' : 'padding-wt-strip'}`}
        >
          {showStrip && showStrip.enable ? (
            <NavStrip dataLocale={this.props.dataLocale} redisCommonData={redisCommonData} />
          ) : (
            <nav
              aria-label="Useful links"
              className={`topNav_bar is-${this.state.headerScroll ? 'scroll' : 'no-scroll'}`}
            >
              <ul className="display-flex">
                {topNavData.topBarNavLeft &&
                  topNavData.topBarNavLeft.map((item, index) => {
                    const dataAttr =
                      item.gaObj && Object.keys(item.gaObj).length > 0
                        ? setDataAttr(item.gaObj)
                        : null;
                    if (item.url && item.url?.indexOf('http') > -1) {
                      const hrefUrl =
                        item.url && item.url?.indexOf('compare-looks') > -1
                          ? new URL(item.url)
                          : item.url;
                      return (
                        <li key={item.label + index} className="menuItem">
                          <a
                            {...dataAttr}
                            className="getGaData"
                            href={hrefUrl.pathname ? hrefUrl.pathname : hrefUrl}
                            target="_self"
                            title={item.label}
                            onClick={() => {
                              // evt.preventDefault();
                              window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                              if (item.url && item.url?.indexOf('compare-looks') > -1) {
                                localStorage.setItem('dittoCompare', window.location.href);
                              }
                              if (window.dtm.LenskartRewamp) {
                                window.dtm.LenskartRewamp.header.click.headerClick(
                                  this.props.section,
                                  item.label,
                                  this.props.loginStatus
                                );
                              }
                              window.location.href = item.url;
                            }}
                          >
                            {item.label}
                          </a>
                        </li>
                      );
                    } else if (item.facetime) {
                      return (
                        <li key={item.label + index}>
                          <a
                            href={`tel:${item.facetime}`}
                            {...dataAttr}
                            className="getGaData"
                            onClick={evt => {
                              evt.preventDefault();
                              if (window.dtm.LenskartRewamp) {
                                window.dtm.LenskartRewamp.header.click.headerClick(
                                  this.props.section,
                                  item.label,
                                  this.props.loginStatus
                                );
                              }
                              window.location.href = `tel:${item.facetime}`;
                            }}
                          >
                            {item.label}
                          </a>
                        </li>
                      );
                    }
                    return (
                      <li key={item.label + index} className="menuItem">
                        {item.url &&
                        (isSupported === 'STANDARD' ||
                          !(item.url?.indexOf('compare-looks') !== -1)) ? (
                          <Link
                            className="getGaData"
                            to={item.url}
                            {...dataAttr}
                            onClick={() => {
                              window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                              if (item.url && item.url?.indexOf('compare-looks') > -1) {
                                localStorage.setItem('dittoCompare', window.location.href);
                              }
                              if (window.dtm.LenskartRewamp) {
                                window.dtm.LenskartRewamp.header.click.headerClick(
                                  this.props.section,
                                  item.label,
                                  this.props.loginStatus
                                );
                              }
                            }}
                          >
                            {item.label}
                          </Link>
                        ) : (
                          ''
                        )}
                      </li>
                    );
                  })}
              </ul>
            </nav>
          )}
          {/* <input
            disabled
            name="hidden-Field"
            style={{
              width: '20px',
              height: '17px',
              visibility: !hostCountry ? 'hidden' : 'visible',
            }}
            value={localeInfo.countryCode}
          /> */}
          {showStrip && showStrip.enable ? null : (
            <nav aria-label="Useful links" className="topRight">
              <ul className="display-flex">
                {/* topNavData.topBarNavRight && topNavData.topBarNavRight.map(item => {
                            return (
                                <a
                                    className="topRightLink"
                                    href={item.url}
                                    title={item.label}
                                    key={item.label}
                                    onClick={() => {
                                        window.sessionStorage.setItem('previousChannel', window.dtm.channel);
                                        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.header.click.headerClick(this.props.section, item.label, this.props.loginStatus);
                                    }}
                                >
                                    <i className={`${item.iconClass} topIcon`}></i>
                                    <span className="topSpan">{item.label}</span>
                                </a>
                            );
                        }) */}
                <li
                  className="topRightLink cursor-pointer"
                  data-testid="topnav-contactus"
                  onClick={() => this.handleWidget(newBot)}
                >
                  {CONTACT_US}
                </li>
              </ul>
            </nav>
          )}
        </div>
        {showChatBot && this.state.showChatIcon && !newBot && (
          <a
            className="buyonChat"
            data-testid="buyonChat"
            onClick={() => this.handleWidget(newBot)}
          >
            <i className="fa fa-comments"></i>
          </a>
        )}
      </div>
    );
  }
}

TopNavBar.defaultProps = {
  topNavData: {},
};

export default TopNavBar;
